exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".input-form-control{width:100%}.input-form-control .label{text-align:left;font-size:13px;color:rgba(0,0,0,0.54)}.input-form-control.masked-input{margin-bottom:7px;margin-top:7px}.input-form-control>div{margin-top:6px}.input-form-control .error-message{color:#F44336}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss","plugins":[null,null]}!./src/components/MaskedInput/style.scss
// module id = 1475
// module chunks = 0